/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagSection } from '../../models/tag-section';

export interface ContactGetTagList$Params {

/**
 * GUID of the user contact
 */
  userId: string;
}

export function contactGetTagList(http: HttpClient, rootUrl: string, params: ContactGetTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
  const rb = new RequestBuilder(rootUrl, contactGetTagList.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagSection>>;
    })
  );
}

contactGetTagList.PATH = '/contact/{userId}/tag/list';
